import { Injectable } from "@angular/core"
import { TemplateResponse } from "@api/communication/models/template"
import { BetaFeatures } from "@api/utility/models/BetaFeatures"

@Injectable({
  providedIn: "root",
})
export class TemplateService {
  private template: TemplateResponse = null
  private isNewTemplate: boolean = false
  private duplicateCall: boolean = false
  private betaFeatures: BetaFeatures = null
  private recentlyExitedTemplateId: string = null
  private returnTab: string = null
  private returnScrollTop: number = 0
  constructor() {}

  public setTemplate(value: TemplateResponse) {
    this.template = value
  }
  public resetTemplate() {
    this.template = null
  }

  public setBetaFeatures(value: BetaFeatures) {
    this.betaFeatures = value
  }
  public getBetaFeatures(): BetaFeatures {
    return this.betaFeatures
  }

  getTemplate() {
    return this.template
  }

  public setIsNewTemplate(value: boolean) {
    this.isNewTemplate = value
  }
  public getIsNewTemplate(): boolean {
    return this.isNewTemplate
  }
  public setDuplicateCall(value: boolean) {
    this.duplicateCall = value
  }
  public getDuplicateCall(): boolean {
    return this.duplicateCall
  }
  public setRecentlyExitedTemplateId(value: string) {
    this.recentlyExitedTemplateId = value
  }
  public getRecentlyExitedTemplateId(): string {
    return this.recentlyExitedTemplateId
  }
  public setReturnTab(value: string) {
    this.returnTab = value
  }
  public getReturnTab(): string {
    return this.returnTab
  }
  public setReturnScrollTop(value: number) {
    this.returnScrollTop = value
  }
  public getReturnScrollTop(): number {
    return this.returnScrollTop
  }
}
